import {Component, inject, signal, WritableSignal} from '@angular/core';
import {MatDialog, MatDialogRef} from '@angular/material/dialog';
import { ApiCallService } from '../../../services/api-call.service';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import {WeaveButtonComponent} from "../../../shared/forms/weave-button/weave-button.component";
import {BlockUI, BlockUIModule, NgBlockUI} from "ng-block-ui";
import {ShortWeaveLoaderComponent} from "../../../shared/loaders/short-weave-loader/short-weave-loader.component";
import {Session} from "../../../services/session.service";
import {first} from "rxjs/operators";
import {AccountManagementModalComponent} from "../account-management-modal/account-management-modal.component";
import {DatePipe} from "@angular/common";

@Component({
  selector: 'app-cancel-account-modal',
  templateUrl: './cancel-account-modal.component.html',
  styleUrls: ['./cancel-account-modal.component.scss'],
  standalone: true,
  imports: [
    MatButtonModule,
    MatDialogModule,
    MatProgressSpinnerModule,
    MatIconModule,
    WeaveButtonComponent,
    BlockUIModule,
    DatePipe
  ]
})
export class CancelAccountModalComponent {
  private readonly dialogRef = inject(MatDialogRef<CancelAccountModalComponent>);
  private readonly dialog = inject(MatDialog);
  private readonly apiService = inject(ApiCallService);
  private readonly session = inject(Session);
  @BlockUI('loadingUI') blockUI: NgBlockUI;
  blockTemplate = ShortWeaveLoaderComponent;
  loading: WritableSignal<boolean> = signal(false);
  error: WritableSignal<string | null> = signal(null);
  protected readonly cancellationDate = this.session.getAccountStatus()?.subscription?.nextBillingDate;

  cancelAccount() {
    this.loading.set(true);
    this.error.set(null);
    this.blockUI.start();
    this.apiService.getData('/disableAutoRenew', null).subscribe({
      next: () => {
        this.loading.set(false);
        this.blockUI.stop();
        this.dialogRef.close(true);
        this.session.reload().pipe(first()).subscribe(() =>{
            // Open the account management modal after cancelling the account
          this.dialog.open(AccountManagementModalComponent, {
            width: '600px',
            disableClose: false
          })
        });
      },
      error: () => {
        this.loading.set(false);
        this.blockUI.stop();
        this.error.set('An error occurred while cancelling the account. Please try again later.');
      }
    });
  }

  close() {
    this.dialogRef.close(false);
  }

}
